
import React from 'react';
import { keyPress } from '../helpers';
import DOMPurify from 'dompurify';

import './Button.scss';

interface IProps {
    buttonClass?: string;
    iconClass?: string;
    iconSrc?: string;
    altText?: string;
    buttonText: string;
    onClick?: Function;
    disabled?: boolean;
    title?: string;
    iconSVG?: string;
    dataTestId?: string;
    ariaLabel?: string;
    ariaPressed?: boolean;
}

const Button: React.FC<IProps> = ({
    dataTestId = 'btn',
    buttonClass = '',
    iconSrc = '',
    iconClass = '',
    altText = '',
    buttonText = '',
    disabled = false,
    title = '',
    ariaLabel,
    ariaPressed,
    onClick,
    iconSVG
}) => {
    return (
        <button
            data-testid={dataTestId}
            aria-label={ariaLabel}
            aria-pressed={ariaPressed}
            title={title}
            tabIndex={0}
            className={buttonClass}
            onClick={() => onClick()}
            onKeyPress={(e: React.KeyboardEvent<HTMLButtonElement>) => keyPress(e, () => onClick())}
            disabled={disabled}>
            {iconClass && iconClass !== '' && <i className={`icon ${iconClass}`} aria-hidden="true"></i>}
            {iconSVG && iconSVG !== '' && <span className="icon-svg" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(iconSVG) }}></span>}
            {iconSrc.trim() !== '' && <img src={iconSrc} className="icon" alt={altText} />}
            {buttonText}
        </button>
    );
};

export default Button;
